module.exports = __webpack_public_path__ + "img/3.3e5b468d.png";